export const GET_DOCUMENT = 'GET_DOCUMENT';
export const SET_FOLDERS = 'SET_FOLDERS';
export const SET_FILES = 'SET_FILES';
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
